import styled from "styled-components";

export const PlayControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;  
  div {
    cursor: pointer;
  }
`;

export const TrackControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;  
`;

export const PlayControlWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  
  @media ${(props) => props.theme.device.lg} {
    background-color: ${(props) => props.theme.colors.neutrals.primary[600]};
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
  }
`;

export const VolumeControls = styled.span`
  position: relative;
  
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
    
  span.price {
    width: 3.125rem;
    min-width: 3.125rem;
    padding: 0.25rem;
  }

  @media ${(props) => props.theme.device.lg} {
    .add-to-cart {
      width: 5.5rem;
    }

    span.price {
      width: 4rem;
      text-align: center;
      padding-inline: 0;
    }
  }
  
  gap: 0.8rem;
`;

export const LoadWrapper = styled.div`
  margin-top: -0.25rem;
  height: 1.5rem;
  width: 1.5rem;
  svg path {
    fill: ${(props) => props.theme.colors.neutrals.primary.graytext};
  }
`;
